export const FILTERS = {
  all: 'all',
  active: 'active',
  completed: 'completed',
};

export const USER = {
  id: 440,
  name: 'Galina Lozinska',
  username: 'lozinska',
  phone: '0967784857',
  email: 'galinkalozinska@gmail.com',
};
